import React, { useState } from 'react';
import Select from 'react-select';

const AddUserModal = ({ isOpen, setIsOpen, statusOptions, handleSubmit, couponform, handleChange, setCouponForm }) => {
    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">User Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="email" className="oms-form-label">
                            Email
                        </label>
                        <input
                            type="text"
                            id="email"
                            name='email'
                            value={couponform.email}
                            onChange={handleChange}
                            placeholder="Enter Email"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="password" className="oms-form-label">
                            Password 
                        </label>
                        <input
                            type="text"
                            id="password"
                            name='password'
                            value={couponform.password}
                            onChange={handleChange}
                            placeholder="Enter Password"
                           
                        />

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="full_name" className="oms-form-label">
                            Full Name
                        </label>
                        
                            <input
                                type="text"
                                id="full_name"
                                name="full_name"
                                value={couponform.full_name}
                                onChange={handleChange}
                                placeholder="Enter Full Name"
                               
                            />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="mobile" className="oms-form-label">
                            Mobile
                        </label>
                        <input
                            type="text"
                            id="mobile"
                            name='mobile'
                            value={couponform.mobile}
                            onChange={handleChange}
                            placeholder='Enter Mobile Number'
                        />
                    </div>
                   
                    
                    {/* <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select
                            id="status"
                            options={statusOptions}
                            onChange={(selectedOption) =>
                                setCouponForm((prev) => ({ ...prev, status: selectedOption }))
                            }
                            placeholder="Select status"
                        />
                    </div> */}
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddUserModal;
